import { useStyles } from './styles';
import ServiceCard from '../ServiceCard';
import { useQuery } from "@apollo/client";
import { GET_SERVICO_BY_REDE, KEY } from "../../Graphql/QUERIES";
import { useParams } from 'react-router';
import { Typography } from '@material-ui/core';

function ServiceTab() {
  const classes = useStyles()
  const { redeId } = useParams();
  const { loading, error, data } = useQuery(GET_SERVICO_BY_REDE, {
    variables: {
      token: KEY,
      tipoRede: parseInt(redeId),
    },
  })

  if (loading) return (
    <Typography>
      Carregando...
    </Typography>
  );
  if (error) return(
    <Typography>
      Ops! Parece que ocorreu um erro. Tente novamente mais tarde.
    </Typography>
  );
  return (
    <div className={classes.tabContainer}>
      {data.ServicoByRedeID.map(service => (
        service.TipoServicoID !== 999 && <ServiceCard id={service.TipoServicoID} key={service.TipoServicoID} service={service.TipoServicoNome} />
      ))}
    </div>
  );
}

export default ServiceTab;